export default {"src":"/_next/static/media/sanddunes.7daa0361.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};